export default "__VITE_ASSET__DfwsczC$__"